import axios from "axios";
import axiosHttp from "../hooks/intercepter";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getToken = () => {
  const Token = localStorage.getItem("AccessToken");
  return !!Token ? Token : "";
};

const getAllMenu = async () => {
  return await axiosHttp.get(`${BASE_URL}/menus`);
};

const getMenuById = async (id) => {
  return axiosHttp.get(`${BASE_URL}/menu/${id}`);
};


const addMenu = async (formData) => {
  // return axiosHttp.post(`${BASE_URL}/menu`, formData, {
  //   method: "POST",
  //   headers: {
  //     "ngrok-skip-browser-warning": "true",
  //     "Content-Type": "application/json"
  //   },
  // });
  const token = getToken() !== null && getToken() !== "" ? JSON.parse(getToken()) : null;
  const header = {
    ...(token !== null && token !== "" && { Authorization: `Bearer ${token}` })
  }

  const response = await axios.post(`${BASE_URL}/menu`, formData, { headers: header });
  return response.data; // Always return the result
};

const deleteMenu = async (data) => {
  return axiosHttp.delete(`${BASE_URL}/menu/${data._id}`);
};

const updateMenu = async (data) => {
  return axiosHttp.patch(`${BASE_URL}/menu/${data._id}`, data, {
    method: "PATCH",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json"
    },
  });
};

const getCategory = async () => {
  return axiosHttp.get(`${BASE_URL}/category/categories`);
};


const addCategory = async (Data) => {
  return axiosHttp.post(`${BASE_URL}/category/addCategory`, Data, {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json"
    },
  });
};

const updateCategory = async (data) => {
  return axiosHttp.put(`${BASE_URL}/category/updateCategory/${data._id}`, data, {
    method: "PUT",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json"
    },
  });
};

const updateSortOrderAll  = async (data) => {
  return axiosHttp.post(`${BASE_URL}/category/update-sort-all`, data);
};

const deleteCategory = async (data) => {
  return axiosHttp.delete(`${BASE_URL}/category/delCategory/${data._id}`);
};

const getAllVegetables = async () => {
  return await axiosHttp.get(`${BASE_URL}/vegetables`);
};

const addVegetable = async (formData) => {
  return axiosHttp.post(`${BASE_URL}/vegetables`, formData, {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteVegetable = async (data) => {
  return axiosHttp.delete(`${BASE_URL}/vegetables/${data._id}`);
};

const updateVegetable = async (formData) => {
  const _id = formData.get('id') || null;
  return axiosHttp.put(`${BASE_URL}/vegetables/${_id}`, formData, {
    method: "PUT",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "multipart/form-data",
    },
  });
};


//Groceries 

const getAllGrocery = async () => {
  return await axiosHttp.get(`${BASE_URL}/grocery`);
};

const addGrocery = async (formData) => {
  return axiosHttp.post(`${BASE_URL}/grocery`, formData, {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteGrocery = async (data) => {
  return axiosHttp.delete(`${BASE_URL}/grocery/${data._id}`);
};

const updateGrocery = async (formData) => {
  const _id = formData.get('id') || null;
  return axiosHttp.put(`${BASE_URL}/grocery/${_id}`, formData, {
    method: "PUT",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "multipart/form-data",
    },
  });
};

//Dairy Items 

const getAllDairyItems = async () => {
  return await axiosHttp.get(`${BASE_URL}/dairyItems`);
};

const addDairyItems = async (formData) => {
  return axiosHttp.post(`${BASE_URL}/dairyItems`, formData, {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteDairyItems = async (data) => {
  return axiosHttp.delete(`${BASE_URL}/dairyItems/${data._id}`);
};

const updateDairyItems = async (formData) => {
  const _id = formData.get('id') || null;
  return axiosHttp.put(`${BASE_URL}/dairyItems/${_id}`, formData, {
    method: "PUT",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "multipart/form-data",
    },
  });
};


//Farsan Items

const getAllFarsanItems = async () => {
  return await axiosHttp.get(`${BASE_URL}/farsanItems`);
};

const addFarsanItems = async (formData) => {
  return axiosHttp.post(`${BASE_URL}/farsanItems`, formData, {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteFarsanItems = async (data) => {
  return axiosHttp.delete(`${BASE_URL}/farsanItems/${data._id}`);
};

const updateFarsanItems = async (formData) => {
  const _id = formData.get('id') || null;
  return axiosHttp.put(`${BASE_URL}/farsanItems/${_id}`, formData, {
    method: "PUT",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "multipart/form-data",
    },
  });
};

//Vasan Items

const getAllVasanItems = async () => {
  return await axiosHttp.get(`${BASE_URL}/vasanItems`);
};

const addVasanItems = async (formData) => {
  return axiosHttp.post(`${BASE_URL}/vasanItems`, formData, {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteVasanItems = async (data) => {
  return axiosHttp.delete(`${BASE_URL}/vasanItems/${data._id}`);
};

const updateVasanItems = async (formData) => {
  const _id = formData.get('id') || null;
  return axiosHttp.put(`${BASE_URL}/vasanItems/${_id}`, formData, {
    method: "PUT",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "multipart/form-data",
    },
  });
};

const getHtmlContent = async (payload) => {
  return axiosHttp.post(`${BASE_URL}/htmlcontent`, payload);
};

const updateMaterialData = async (payload) => {
  return axiosHttp.post(`${BASE_URL}/update-material-data`, payload);
};

const getOrderhtml = async (payload) => {
  return axiosHttp.post(`${BASE_URL}/getorderhtml`, payload);
};

const getGetBillhtml = async (id) => {
  return axiosHttp.post(`${BASE_URL}/getbillhtml/${id}`);
};

//Miscellaneous Items

const getAllMiscellaneousItems = async () => {
  return await axiosHttp.get(`${BASE_URL}/miscellaneous-item/list`);
};

const addMiscellaneousItems = async (payload) => {
  return axiosHttp.post(`${BASE_URL}/miscellaneous-item/add`, payload);
};

const deleteMiscellaneousItems = async (data) => {
  return axiosHttp.delete(`${BASE_URL}/miscellaneous-item/delete/${data._id}`);
};

const updateMiscellaneousItems = async (payload) => {
  const _id = payload.id || null;
  return axiosHttp.put(`${BASE_URL}/miscellaneous-item/update/${_id}`, payload);
};

export {
  getAllMenu,
  addMenu,
  updateMenu,
  deleteMenu,
  getMenuById,

  getCategory,
  addCategory,
  updateCategory,
  updateSortOrderAll,
  deleteCategory,

  getAllVegetables,
  addVegetable,
  deleteVegetable,
  updateVegetable,

  getAllGrocery,
  addGrocery,
  updateGrocery,
  deleteGrocery,

  getAllDairyItems,
  addDairyItems,
  updateDairyItems,
  deleteDairyItems,

  getAllFarsanItems,
  addFarsanItems,
  updateFarsanItems,
  deleteFarsanItems,

  getAllVasanItems,
  addVasanItems,
  updateVasanItems,
  deleteVasanItems,

  getAllMiscellaneousItems,
  addMiscellaneousItems,
  updateMiscellaneousItems,
  deleteMiscellaneousItems,

  getHtmlContent,
  updateMaterialData,
  getOrderhtml,
  getGetBillhtml
};
